import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import StickyHScrollbar from './StickyHScrollbar';

const ROLE_LABELS = { admin: 'Админ', accountant: 'Бухгалтер', manager: 'Менеджер', rop: 'РОП', designer: 'Дизайнер' };

export default function Layout() {
  const { user, logout } = useAuth();

  return (
    <div className="layout">
      <header className="topbar">
        <img className="topbar-logo" src={`${process.env.PUBLIC_URL}/logo.png`} alt="Graffiti Russia" />
        <nav className="topbar-nav">
          {user.role !== 'designer' && (
            <NavLink to="/payments" className={({ isActive }) => isActive ? 'active' : ''}>Заявки</NavLink>
          )}
          {['admin', 'accountant', 'manager', 'rop', 'designer'].includes(user.role) && (
            <NavLink to="/projects" className={({ isActive }) => isActive ? 'active' : ''}>Проекты</NavLink>
          )}
          {['admin', 'accountant', 'rop'].includes(user.role) && (
            <NavLink to="/finance" className={({ isActive }) => isActive ? 'active' : ''}>Финансы</NavLink>
          )}
          {['admin', 'accountant', 'manager', 'rop'].includes(user.role) && (
            <NavLink to="/contractors" className={({ isActive }) => isActive ? 'active' : ''}>Контрагенты</NavLink>
          )}
          {['admin', 'manager', 'rop', 'designer'].includes(user.role) && (
            <NavLink to="/designers" className={({ isActive }) => isActive ? 'active' : ''}>Дизайнеры</NavLink>
          )}
          {user.role === 'admin' && (
            <NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>Пользователи</NavLink>
          )}
          {user.role === 'admin' && (
            <NavLink to="/references" className={({ isActive }) => isActive ? 'active' : ''}>Справочники</NavLink>
          )}
        </nav>
        <div className="topbar-user">
          <span>{user.name}</span>
          <span className="role-badge">{ROLE_LABELS[user.role] || user.role}</span>
          <button className="btn-secondary btn-sm" onClick={logout}>Выйти</button>
        </div>
      </header>
      <main className="main">
        <Outlet />
      </main>
      <StickyHScrollbar />
    </div>
  );
}
